import { render, staticRenderFns } from "./HomeReviews.vue?vue&type=template&id=f449e658&scoped=true"
import script from "./HomeReviews.vue?vue&type=script&lang=js"
export * from "./HomeReviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f449e658",
  null
  
)

export default component.exports